// 导入必要的样式、组件和hooks
import './Dashboard.less';
import { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Navigator from './components/Navagator.jsx';
import { authService, userService, infoController, vidTranslation } from '@/api/index';
// import { useApi } from '@/hooks/useApi.jsx';
import { useDispatch } from 'react-redux';
import member from '@/assets/layouts/dashboard/member.svg';
import member2 from '@/assets/layouts/dashboard/member.png';
import credit from '@/assets/layouts/dashboard/Credits.png';
import discord from '@/assets/layouts/dashboard/discord.png';
import transform from '@/assets/layouts/dashboard/transform.png';
import quit from '@/assets/layouts/dashboard/quit.png';
import select from '@/assets/select.png';
import logo from '@/assets/logot-v3.png';
import { setUserDetailState } from '@/store/slices/userDetail.js';
import DashboardProvider from '@/providers/DashboardProvider.jsx';
import { useDrawer } from '@/hooks/DrawerHooks';
// import { computeDay } from '@/utils/dayjs';
import SentryTracker from '@/utils/Sentry/sentryUtils';
import { useIntercom } from 'react-use-intercom';
import { UploadProvider } from '@/context/vidtranslate/UploadContext';
import { useUploadState } from '@/pages/vidtranslate/state/upload';
import { DISCORD_URL } from '@/pages/home/Home.jsx';
import { useTranslation } from 'react-i18next';
import { checkUrlLanguage } from '@/utils/i18n.ts';
import { UseUserLevel } from '@/hooks/levelHooks.js';
import ImgSetting from '@/assets/layouts/dashboard/home_nav_settings.png';
import message from '@/utils/message';
import MobileGuideImg from '@/assets/mobile_guide_img.png';
import { removeToken, CookiesTrackingCode } from '@/utils/cookie.js';
// import { useTranslate } from '@/hooks/TranslationHooks'
const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent); // Common breakpoint for mobile devices
};
// Function to convert px to rem for mobile devices only
const mobileRem = (px) => {
  if (isMobileDevice()) {
    // Base font size is typically 16px, adjust according to your design
    return `${px / 16}rem`;
  }
  return `${px}px`; // Return px value for desktop
};
// Hook to handle responsive sizing
const useResponsiveSizing = () => {
  const [isMobile, setIsMobile] = useState(isMobileDevice());

  useEffect(() => {
    const handleResize = () => {
      console.log(isMobileDevice(), 'isMobileDevice()');
      if (isMobileDevice()) {
        // You can adjust the base font size calculation based on device width
        // setTimeout(() => {
        const fontSize = document.documentElement.clientWidth / 375; // 375px is typical design width for mobile
        document.documentElement.style.fontSize = `${fontSize}px`;
        // });
      } else {
        // setTimeout(() => {
        document.documentElement.style.fontSize = `16px`;
        // });
      }
      setIsMobile(isMobileDevice());
    };
    if (isMobile) {
      // You can adjust the base font size calculation based on device width
      // setTimeout(() => {
      const fontSize = document.documentElement.clientWidth / 375; // 375px is typical design width for mobile
      document.documentElement.style.fontSize = `${fontSize}px`;
      // });
    } else {
      // setTimeout(() => {
      document.documentElement.style.fontSize = `16px`;
      // }, 50);
    }
    window.addEventListener('resize', handleResize);
    message.close();
    // Set initial font size for root element if mobile

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { isMobile, mobileRem };
};

function Dashboard() {
  const uploadContextValue = useUploadState();
  const dispatch = useDispatch();
  const [userData, setUserData] = useState({});
  const [pointConsume, setPointConsume] = useState([]);
  const [youtobeCreateProject, setYoutobeCreateProject] = useState(false);
  // const [scrollTop, setScrollTop] = useState(0);
  const [childCallback, setChildCallback] = useState(null);
  const [dropOpen, setDropOpen] = useState(false);
  const [languagOpen, setlanguagOpen] = useState(false);
  const [languagType, setLanguagType] = useState(0);
  const { isMobile } = useResponsiveSizing();
  useEffect(() => {
    document.body.classList.toggle('mobile-device', isMobile);
  }, [isMobile]);
  const languageList = [
    {
      lable: 'English',
      code: ['en', 'en-US'],
      originalLanguage: 'English',
      bilingualLanguage: 'Chinese',
    },
    { lable: '日本語', code: ['ja'], originalLanguage: 'Japanese', bilingualLanguage: 'English' },
    {
      lable: 'Português',
      code: ['pt', 'pt-BR'],
      originalLanguage: 'Portuguese',
      bilingualLanguage: 'English',
    },
    { lable: '中文', code: ['zh-CN'], originalLanguage: 'Chinese', bilingualLanguage: 'English' },
  ];
  const [loading, setLoading] = useState(false);

  const [avatarLoading, setAvatarLoading] = useState(true);

  const [needRefreshProjects, setNeedRefreshProjects] = useState(null);
  const [needShowUploadVoice, setNeedShowUploadVoice] = useState(false);
  const [userDetailSuccess, setUserDetailSuccess] = useState(0);

  const { setIsOpen, updataDetail } = useDrawer();
  const [avatarTimestamp, setAvatarTimestamp] = useState(new Date().getTime());
  const { update } = useIntercom();
  const { t } = useTranslation();

  // 获取导航函数
  const navigate = useNavigate();

  const menuRef = useRef(null);
  // 监听滚动事件
  useEffect(() => {
    sessionStorage.setItem('source', null);
    sessionStorage.setItem('campaign', null);
    sessionStorage.setItem('term', null);
    sessionStorage.setItem('ad', null);
    sessionStorage.setItem('recall', null);
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('register') && !sessionStorage.getItem('register')) {
      sessionStorage.setItem('register', '1');
      if (urlParams.get('register') === 'true') {
        const tracking_code = CookiesTrackingCode();
        window.onClickGATrackEvent('signup-google-success', {
          tracking_code,
        });
      } else {
        window.onClickGATrackEvent('login-google-success');
      }
    }
    const homeBox = document.querySelector('.main');
    if (!homeBox) return;

    const handleScroll = () => {
      // setScrollTop(homeBox.scrollTop);
    };

    const handleClickOutside = () => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        mouseLeaveClose();
      }
    };

    homeBox.addEventListener('scroll', handleScroll);
    document.addEventListener('mousedown', handleClickOutside);
    getYoutobeInfo();
    // 清理函数
    return () => {
      homeBox.removeEventListener('scroll', handleScroll);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const getUserDetail = useCallback(async () => {
    setLoading(true);
    setAvatarLoading(true);
    try {
      const res = await userService.userDetail();
      if (res?.code === 0) {
        dispatch(setUserDetailState({ key: 'userDetailState', value: res.data }));
        setUserData(JSON.parse(JSON.stringify(res.data)));
        if (userDetailSuccess === 0) {
          setUserDetailSuccess(Date.now());
        }
        SentryTracker.setUser({
          email: res.data.email,
        });
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
    setAvatarLoading(false);
  }, [dispatch]); // 添加依赖项
  const getPointConsume = useCallback(async () => {
    try {
      const res = await infoController.pointConsume();
      if (res.code == 0) {
        // translation_and_tts: translation入口创建任务，并进行tts /分钟
        // translation: translation入口创建任务 /分钟
        // add_subtitle_and_tts: add_subtitle入口创建任务，并进行tts /分钟
        // add_subtitle: add_subtitle入口创建任务 /分钟
        // rewrite： rewrite入口创建任务 /分钟
        // sentence_modify：每句话的价格 /句
        const data = res.data.sort((a, b) => a.id - b.id);
        setPointConsume(data);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);
  const getYoutobeInfo = useCallback(async () => {
    try {
      const res = await vidTranslation.youtubeDownloadAllowed();
      if (res.code == 0) {
        setYoutobeCreateProject(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  }, []);
  useEffect(() => {
    if (sessionStorage.getItem('intercomUpdate')) {
      update({
        email: userData?.email,
      });
      sessionStorage.setItem('intercomUpdate', '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionStorage.getItem('intercomUpdate')]);
  // 当路由变化时获取用户详情
  useEffect(() => {
    getUserDetail();

    getPointConsume();
  }, [childCallback]);
  useEffect(() => {
    if (updataDetail !== 0) {
      getUserDetail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updataDetail]);

  const handleToDiscord = () => {
    window.onClickGATrackEvent('profile-discord');
    window.open(DISCORD_URL, '_black');
  };

  const handleSignout = async () => {
    window.onClickGATrackEvent('profile-signout');
    await authService.logout();
    removeToken();
    navigate('/login');
  };

  const mouseLeaveClose = () => {
    setDropOpen(false);
    setlanguagOpen(false);
  };
  const mouseHoverShow = () => {
    window.onClickGATrackEvent('navbar-profile');
    setDropOpen(!dropOpen);
    setlanguagOpen(false);
  };

  const handleToSetting = () => {
    navigate('/settings');
    window.onClickGATrackEvent('profile-settings');
    mouseLeaveClose();
  };
  const handleToPricing = () => {
    window.onClickGATrackEvent('navbar-upgrade');
    setIsOpen(true);
  };
  const handleToLanguage = () => {
    const languageCode = localStorage.getItem('i18nextLng') || 'en-US';
    setLanguagType(languageList.findIndex((item) => item.code.includes(languageCode)));
    setlanguagOpen((res) => !res);
  };
  const changeLanguage = (index) => {
    window.onClickGATrackEvent('profile-language');
    const languageCode = languageList[index].code[0];
    checkUrlLanguage(languageCode);
    mouseLeaveClose();
  };
  const buyCredits = (type) => {
    if (type == 0) {
      window.onClickGATrackEvent('profile-upgrade');
    } else if (type == 2) {
      window.onClickGATrackEvent('profile-getcredits');
    }
    setIsOpen(true);
    localStorage.setItem('pricing_type', type);
  };
  // 使用 useMemo 包装 DashboardProvider 的值
  const providerValue = useMemo(
    () => ({
      userData,
      setChildCallback,
      avatarLoading,
      setAvatarLoading,
      needRefreshProjects,
      setNeedRefreshProjects,
      needShowUploadVoice,
      setNeedShowUploadVoice,
      userDetailSuccess,
      setUserDetailSuccess,
      pointConsume,
      youtobeCreateProject,
      setYoutobeCreateProject,
      languageList,
    }),
    [
      userData,
      setChildCallback,
      avatarLoading,
      setAvatarLoading,
      needRefreshProjects,
      setNeedRefreshProjects,
      needShowUploadVoice,
      setNeedShowUploadVoice,
      userDetailSuccess,
      setUserDetailSuccess,
      pointConsume,
      youtobeCreateProject,
      setYoutobeCreateProject,
      languageList,
    ],
  );

  useEffect(() => {
    if (userData?.avatar) {
      setAvatarTimestamp(new Date().getTime());
    }
  }, [userData]);
  return (
    <div className="dashboard-layout">
      {/* 头部 */}
      <div className="header">
        {/* {scrollTop > 0 && <div className="header_shadow"></div>} */}
        {/* <div className="discord-logo" onClick={handleToDiscord}>
              <Icon name="icon-discord"></Icon>
            </div> */}
        {/* 会员升级按钮 */}
        <img src={logo} className="imgs" alt="" />

        <div className="member_icon" onClick={handleToPricing}>
          {t('As_Home_TopNavUpgrade')}
          <img className="member_img" src={member} alt="" />
        </div>
        {/* 用户头像下拉菜单 */}
        <div className="dropdown dropdown-bottom dropdown-end dropdown-open" style={{ zIndex: 99 }}>
          {avatarLoading ? (
            <div className="skeleton shrink-0 rounded-full"></div>
          ) : (
            <img
              tabIndex={0}
              className="avatar_img"
              src={`${userData?.avatar}?timestamp=${avatarTimestamp}`}
              alt=""
              onClick={() => mouseHoverShow()}
            />
          )}

          {dropOpen && (
            <ul
              tabIndex={0}
              className="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow"
              ref={menuRef}>
              <div className="rashaun_box">
                <div className="title">{userData?.username}</div>
                <div className="email">{userData?.email}</div>
              </div>
              <div className="userLevel">
                <div className="rashaun_box user_credits">
                  <img className="credits_img" src={member2} alt="" />
                  <div className="credits credits_no">
                    <div className="levelTip">{t(UseUserLevel(userData?.subscription?.id))}</div>
                    <div className="menu_more" onClick={() => buyCredits(0)}>
                      {t('As_Home_CreditLimit')}
                    </div>
                  </div>
                </div>
                <div className="rashaun_box user_credits">
                  <img className="credits_img" src={credit} alt="" />
                  <div className="credits credits_no">
                    <div>
                      <span className="levelTip">{t('As_Home_Userprofile3')}</span>
                      <span className="credits_num">{userData?.actualTotalPoints}</span>
                    </div>
                    <div className="menu_more" onClick={() => buyCredits(2)}>
                      {t('As_Home_Userprofile4')}
                    </div>
                  </div>
                </div>
              </div>
              <li className="li_item first_li" onClick={handleToSetting}>
                <a className="meanblock">
                  <img src={ImgSetting} />
                  {t('As_Home_Settingsoption')}
                </a>
              </li>
              <li
                className="li_item dropdown dropdown-left dropdown-end dropdown-open"
                onMouseEnter={handleToLanguage}
                onMouseLeave={() => {
                  setlanguagOpen(false);
                }}>
                <a tabIndex={0} role="button">
                  <img src={transform} />
                  {t('As_Home_Languageoption')}
                </a>
                {languagOpen && (
                  <ul
                    tabIndex={0}
                    className="dropdown-content menu bg-base-100 z-[99] w-52 p-2 language_list shadow-sm rounded-box">
                    {languageList.map((res, index) => (
                      <li
                        className="language_item"
                        key={index}
                        onClick={() => changeLanguage(index)}>
                        <a className="language_state">
                          <span className="language_label">{res.lable}</span>
                          {languagType == index && <img src={select} />}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
              <li className="li_item" onClick={handleToDiscord}>
                <a>
                  <img src={discord} />
                  {t('As_Home_Socialmedialink')}
                </a>
              </li>
              <li onClick={handleSignout} className="li_item">
                <a>
                  <img src={quit} />
                  {t('As_Nav_Avatar2')}
                </a>
              </li>
            </ul>
          )}
        </div>
      </div>
      <div className="dashboard_box">
        {/* 左侧导航栏 */}
        <div className="layout_left">
          <Navigator value={loading} userData={userData} />
        </div>
        {/* 右侧主内容区 */}
        <div className="layout_right">
          {/* 主内容区 */}
          <div className="main custom-scrollbar">
            <DashboardProvider value={providerValue}>
              <UploadProvider value={{ ...uploadContextValue }}>
                <Outlet></Outlet>
              </UploadProvider>
            </DashboardProvider>
          </div>
        </div>
      </div>

      {isMobileDevice() && (
        <div className="mobile_guide_page">
          <div className="guide_box">
            <img src={MobileGuideImg} className="mobile_guide_image" />
            <div className="mobile_guide_text">
              For a better experience
              <br /> Go to the PC
            </div>
            <div className="mobile_guide_url">addsubtitle.ai</div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
